import { render, staticRenderFns } from "./QuestionnaireIcon.vue?vue&type=template&id=23840444&scoped=true&"
import script from "./QuestionnaireIcon.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireIcon.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireIcon.vue?vue&type=style&index=0&id=23840444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23840444",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
